import React from "react";
import { Box, Container, Heading, Text, Wrap, WrapItem, Badge, useColorModeValue } from "@chakra-ui/react";
import { motion, useReducedMotion } from "framer-motion";
import { usePublicGlassSurface } from "../../common/publicVisual";

const TAGS = [
  "Google Calendar",
  "Email reminders",
  "SMS & voice calls (Twilio)",
  "Optional WhatsApp (where you configure it)",
  "Razorpay for AI Usage Credit packs",
];

const MotionSpan = motion.span;

export default function IntegrationsBrief() {
  const glass = usePublicGlassSurface();
  const muted = useColorModeValue("gray.600", "gray.400");
  const reduceMotion = useReducedMotion();

  return (
    <Box as="section" py={{ base: 10, md: 12 }} bg="transparent">
      <Container maxW="container.xl" px={{ base: 4, md: 6 }}>
        <Box
          borderRadius="2xl"
          borderWidth="1px"
          px={{ base: 5, md: 8 }}
          py={{ base: 6, md: 8 }}
          sx={{ transformStyle: "preserve-3d" }}
          {...glass}
        >
          <Heading as="h2" size="md" fontWeight="bold" mb={2}>
            Works with tools you already use
          </Heading>
          <Text fontSize="sm" color={muted} mb={6} maxW="2xl" lineHeight="tall">
            Connect calendar and reminders, pay for voice securely, and optionally mirror alerts to WhatsApp when enabled.
          </Text>
          <Wrap spacing={3}>
            {TAGS.map((t) => (
              <WrapItem key={t}>
                <MotionSpan
                  style={{ display: "inline-block", transformStyle: "preserve-3d" }}
                  whileHover={
                    reduceMotion
                      ? undefined
                      : { y: -5, rotateX: 8, scale: 1.03, transition: { type: "spring", stiffness: 400, damping: 22 } }
                  }
                >
                  <Badge
                    colorScheme="teal"
                    variant="subtle"
                    px={3}
                    py={1.5}
                    borderRadius="full"
                    fontSize="xs"
                    boxShadow="md"
                  >
                    {t}
                  </Badge>
                </MotionSpan>
              </WrapItem>
            ))}
          </Wrap>
        </Box>
      </Container>
    </Box>
  );
}
